import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, mergeProps as _mergeProps, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "xfields" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = { class: "input-wrapper-outer" }
const _hoisted_5 = ["title", "selected", "value"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "input-wrapper-outer" }
const _hoisted_8 = { class: "input-wrapper-inner" }
const _hoisted_9 = { class: "prefix" }

import { onMounted, watch, ref, toRefs } from "vue";
import BaseFormField from "@/components/form-fields/BaseFormField.vue";
import { useTypeStore } from "@/store/store/typeStore";
import { AddressTypeIds } from "@/types/address";
import { Field as VeeField, ErrorMessage } from "vee-validate";
import { useAddressForm } from "@/composables/address/useAddressForm";
import { FormModes } from "@/types/form";
import { ConsentServiceEntityTypeIds } from "@/types/consents";
import type { ApplicantAddress } from "@/types/applicant";
import { LOSType } from "@/models/opal";


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressInput',
  props: {
    disabled: { type: Boolean, default: true },
    mode: {},
    initialValues: {},
    formData: {},
    header: { default: "Address" },
    entityTypeId: { default: ConsentServiceEntityTypeIds.Application },
    showHeader: { type: Boolean, default: true },
    showUnitType: { type: Boolean, default: true }
  },
  emits: ["update:address"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

useTypeStore();

const emit = __emit;

const props = __props;

const { mode, entityTypeId, initialValues, showUnitType } = toRefs(props);

const address = ref<ApplicantAddress>({
  address1: "",
  address2: null as null | string,
  addressId: props.initialValues?.addressId || 0,
  addressTypeId: props.initialValues?.addressTypeId || AddressTypeIds.PERMANENT,
  addressTypeName: props.initialValues?.addressTypeName || "",
  addressUnitTypeId: null as null | number,
  addressUnitTypeName: null as null | string,
  applicantId: props.initialValues?.applicantId || 0,
  id: props.initialValues?.id || 0,
  city: "",
  stateId: 0,
  stateName: "",
  postalCode: "",
  countryId: 0,
  countryName: "",
});

const {
  address2,
  addressSchema,
  addressBackup,
	addressUnitTypePrefixes,
  addressUnitTypes,
  addressValidationSchema,
  countryOptions,
  discardChanges,
  errors,
  formattedAddress2,
  hasChanges,
  handleFieldChange,
  hasErrors,
  originalAddress,
  postalCode,
  postalCodeExtension,
  prefixes,
  removePrefix,
  resetSchemas,
  selectedUnitType,
  setAddress,
  setValues,
  statesOptions,
  updatedAddress,
  values,
} = useAddressForm({
  address,
  mode,
  entityTypeId,
  initialValues,
  showUnitType,
});

function setAddressInputs(
  values: undefined | null | Record<string, any>,
  shouldValidate?: undefined | boolean
) {
  if (values) {
    const currentValues = JSON.parse(JSON.stringify(values));

    const selectedUnitType =
      currentValues?.addressUnitTypeId && currentValues?.addressUnitTypeId > 0
        ? addressUnitTypes.value.find(
            (t: LOSType) => t.id === Number(currentValues?.addressUnitTypeId)
          )
        : null;

    address.value.address1 = currentValues.address1;
    address.value.address2 = showUnitType.value
      ? currentValues.address2
      : removePrefix(currentValues.address2, prefixes.value);
    address.value.addressId = currentValues?.addressId;
    address.value.addressTypeId =
      currentValues?.addressTypeId || AddressTypeIds.PERMANENT;
    address.value.addressTypeName = currentValues?.addressTypeName;
    address.value.addressUnitTypeId = currentValues?.addressUnitTypeId;
    address.value.addressUnitTypeName = selectedUnitType?.name || null;
    address.value.applicantId = currentValues?.applicantId;
    address.value.id = currentValues?.id;
    address.value.city = currentValues?.city;
    address.value.stateId = currentValues?.stateId;
    address.value.stateName = currentValues?.stateName;
    address.value.postalCode = currentValues?.postalCode;
    address.value.countryId = currentValues?.countryId;
    address.value.countryName = currentValues?.countryName;
    // setValues(accountDetails.value, shouldValidate);
  }
}

onMounted(() => {
  setAddress();
});

watch(
  () => address.value,
  () => {
    setValues(address.value);
    emit("update:address", address.value);
  },
  { deep: true }
);

watch(
  () => props.initialValues,
  () => {
    setAddress();
  },
  { deep: true }
);

watch(
  () => props.disabled,
  () => {
    if (props.disabled) {
      resetSchemas();
    }
  }
);

__expose({
  address,
  address2,
  addressBackup,
  addressSchema,
	addressUnitTypePrefixes,
  addressUnitTypes,
  addressValidationSchema,
  countryOptions,
  discardChanges,
  errors,
  formattedAddress2,
  hasChanges,
  hasErrors,
  originalAddress,
  postalCode,
  postalCodeExtension,
  resetSchemas,
  selectedUnitType,
  setAddress,
	setAddressInputs,
  setValues,
  statesOptions,
  updatedAddress,
  values,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["xform-section", [{ draw: _unref(entityTypeId) === _unref(ConsentServiceEntityTypeIds).Draw }]]),
    id: "address"
  }, [
    (__props.showHeader)
      ? (_openBlock(), _createElementBlock("h3", _hoisted_1, _toDisplayString(__props.header), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).address1,
        modelValue: address.value.address1,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((address.value.address1) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_unref(handleFieldChange)('address1', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      (_unref(showUnitType))
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "xfield form-field",
            disabled: __props.disabled,
            id: "unitType"
          }, [
            _createElementVNode("div", _hoisted_4, [
              _cache[18] || (_cache[18] = _createElementVNode("label", {
                class: "label cuscd-form-field-label",
                for: "addressUnitTypeId"
              }, "Unit Type", -1)),
              _createVNode(_unref(VeeField), {
                name: "addressUnitTypeId",
                modelValue: address.value.addressUnitTypeId,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address.value.addressUnitTypeId) = $event)),
                onHandleChange: _cache[4] || (_cache[4] = ($event: any) => (_unref(handleFieldChange)('addressUnitTypeId', $event)))
              }, {
                default: _withCtx(({ field }) => [
                  _withDirectives(_createElementVNode("select", _mergeProps({
                    class: "form-control select",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address.value.addressUnitTypeId) = $event))
                  }, field, { id: "addressUnitTypeId" }), [
                    _cache[17] || (_cache[17] = _createElementVNode("option", { value: null }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(addressUnitTypes), (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option.id,
                        title: option.name,
                        selected: option.id === Number(address.value.addressUnitTypeId),
                        value: option.id
                      }, _toDisplayString(option.name), 9, _hoisted_5))
                    }), 128))
                  ], 16), [
                    [_vModelSelect, address.value.addressUnitTypeId]
                  ])
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createElementVNode("div", null, [
                _createVNode(_unref(ErrorMessage), {
                  class: "error-message",
                  name: "addressUnitTypeId"
                })
              ])
            ])
          ], 8, _hoisted_3))
        : _createCommentVNode("", true),
      (_unref(showUnitType))
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "xfield form-field xfield-group",
            disabled: __props.disabled,
            id: "unitNumber"
          }, [
            _createElementVNode("div", _hoisted_7, [
              _cache[19] || (_cache[19] = _createElementVNode("label", {
                class: "label cuscd-form-field-label",
                for: "address2"
              }, "Unit Number", -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(selectedUnitType)?.abbreviation), 1),
                _createVNode(_unref(VeeField), {
                  type: "text",
                  id: "address2",
                  name: "address2",
                  modelValue: address.value.address2,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address.value.address2) = $event)),
                  onHandleChange: _cache[6] || (_cache[6] = ($event: any) => (_unref(handleFieldChange)('address2', $event)))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", null, [
                _createVNode(_unref(ErrorMessage), {
                  class: "error-message",
                  name: "address2"
                })
              ])
            ])
          ], 8, _hoisted_6))
        : _createCommentVNode("", true),
      (!_unref(showUnitType))
        ? (_openBlock(), _createBlock(BaseFormField, {
            key: 2,
            schema: _unref(addressSchema).address2,
            modelValue: address.value.address2,
            "onUpdate:modelValue": [
              _cache[7] || (_cache[7] = ($event: any) => ((address.value.address2) = $event)),
              _cache[8] || (_cache[8] = ($event: any) => (_unref(handleFieldChange)('address2', $event)))
            ]
          }, null, 8, ["schema", "modelValue"]))
        : _createCommentVNode("", true),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).city,
        modelValue: address.value.city,
        "onUpdate:modelValue": [
          _cache[9] || (_cache[9] = ($event: any) => ((address.value.city) = $event)),
          _cache[10] || (_cache[10] = ($event: any) => (_unref(handleFieldChange)('city', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).stateId,
        modelValue: address.value.stateId,
        "onUpdate:modelValue": [
          _cache[11] || (_cache[11] = ($event: any) => ((address.value.stateId) = $event)),
          _cache[12] || (_cache[12] = ($event: any) => (_unref(handleFieldChange)('stateId', $event)))
        ],
        modelModifiers: { number: true },
        options: _unref(statesOptions)
      }, null, 8, ["schema", "modelValue", "options"]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).postalCode,
        modelValue: address.value.postalCode,
        "onUpdate:modelValue": [
          _cache[13] || (_cache[13] = ($event: any) => ((address.value.postalCode) = $event)),
          _cache[14] || (_cache[14] = ($event: any) => (_unref(handleFieldChange)('postalCode', $event)))
        ]
      }, null, 8, ["schema", "modelValue"]),
      _createVNode(BaseFormField, {
        schema: _unref(addressSchema).countryId,
        modelValue: address.value.countryId,
        "onUpdate:modelValue": [
          _cache[15] || (_cache[15] = ($event: any) => ((address.value.countryId) = $event)),
          _cache[16] || (_cache[16] = ($event: any) => (_unref(handleFieldChange)('countryId', $event)))
        ],
        modelModifiers: { number: true },
        options: _unref(countryOptions)
      }, null, 8, ["schema", "modelValue", "options"])
    ])
  ], 2))
}
}

})